import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'flowbite';
// import 'bootstrap/dist/css/bootstrap.css'
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import {StyledEngineProvider} from '@mui/material';

ReactDOM.render(
  <BrowserRouter>
    <StyledEngineProvider injectfirst>
        <App />
    </StyledEngineProvider>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
